import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import style from "../../../scss/Conteo.module.scss";

// Cierre del escrutinio: observación obligatoria de la mesa y check de
// "mesa con problemas" para solicitar reconteo (como en las constancias del E-14).
const ModalCierreComponent = ({ show, onHide, onConfirmar, novedades, sinFoto, procesando }) => {
  const [observacion, setObservacion] = useState("");
  const [tieneProblema, setTieneProblema] = useState(false);
  const [solicitadoPor, setSolicitadoPor] = useState("");
  const [enRepresentacionDe, setEnRepresentacionDe] = useState("");

  // al abrir: si el acta no cuadra se sugiere marcar la mesa con problemas
  useEffect(() => {
    if (!show) return;
    setObservacion("");
    setTieneProblema(novedades.length > 0);
    setSolicitadoPor("");
    setEnRepresentacionDe("");
  }, [show, novedades.length]);

  // si todo cuadra y no se marca problema, la observación es opcional
  // (el backend aplica la misma regla)
  const observacionObligatoria = novedades.length > 0 || tieneProblema;

  const handleSubmit = (event) => {
    event.preventDefault();
    onConfirmar({
      observacion: observacion.trim(),
      tieneProblema,
      reconteoSolicitadoPor: tieneProblema ? solicitadoPor.trim() : "",
      reconteoEnRepresentacionDe: tieneProblema ? enRepresentacionDe.trim() : "",
    });
  };

  return (
    // enforceFocus false: deja usar las alertas de SweetAlert encima del modal
    <Modal show={show} onHide={onHide} centered enforceFocus={false}>
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title as="h2" className={style.modalTitulo}>
            Cerrar escrutinio de la mesa
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {novedades.length > 0 && (
            <div className="alert alert-warning">
              <p className="fw-semibold mb-1">El acta presenta novedades:</p>
              <ul className="mb-0 ps-3">
                {novedades.map((novedad) => (
                  <li key={novedad}>{novedad}</li>
                ))}
              </ul>
            </div>
          )}

          {sinFoto && (
            <div className="alert alert-info">
              Vas a cerrar sin la foto del E-14. Podrás cargarla después desde esta misma mesa.
            </div>
          )}

          <label htmlFor="observacion" className={style.etiqueta}>
            Observación de la mesa{" "}
            {observacionObligatoria ? (
              <span className={style.obligatorio}>(obligatoria)</span>
            ) : (
              <span className={style.opcional}>(opcional)</span>
            )}
          </label>
          <textarea
            id="observacion"
            className="form-control"
            rows={4}
            maxLength={2000}
            value={observacion}
            onChange={(e) => setObservacion(e.target.value)}
            placeholder={
              observacionObligatoria
                ? "Describe las novedades de la mesa…"
                : "El acta cuadra: puedes dejarla vacía o anotar las constancias de los jurados"
            }
            required={observacionObligatoria}
          />

          <div className={`form-check ${style.check}`}>
            <input
              id="tieneProblema"
              type="checkbox"
              className="form-check-input"
              checked={tieneProblema}
              onChange={(e) => setTieneProblema(e.target.checked)}
            />
            <label htmlFor="tieneProblema" className="form-check-label">
              Esta mesa tiene problemas: solicitar reconteo de votos
            </label>
          </div>

          {tieneProblema && (
            <div className="row g-2 mt-1">
              <div className="col-12 col-sm-6">
                <label htmlFor="solicitadoPor" className={style.etiqueta}>
                  Solicitado por
                </label>
                <input
                  id="solicitadoPor"
                  className="form-control"
                  maxLength={150}
                  value={solicitadoPor}
                  onChange={(e) => setSolicitadoPor(e.target.value)}
                />
              </div>
              <div className="col-12 col-sm-6">
                <label htmlFor="enRepresentacionDe" className={style.etiqueta}>
                  En representación de
                </label>
                <input
                  id="enRepresentacionDe"
                  className="form-control"
                  maxLength={150}
                  value={enRepresentacionDe}
                  onChange={(e) => setEnRepresentacionDe(e.target.value)}
                />
              </div>
            </div>
          )}

          <p className={style.ayuda}>Al cerrar, el acta queda bloqueada. Solo un administrador puede reabrirla.</p>
        </Modal.Body>

        <Modal.Footer className={style.acciones}>
          <button type="button" className={`btn btn-outline-secondary ${style.boton}`} onClick={onHide} disabled={procesando}>
            Cancelar
          </button>
          <button type="submit" className={`btn btn-success ${style.boton}`} disabled={procesando}>
            {procesando ? "Cerrando…" : "Cerrar escrutinio"}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default ModalCierreComponent;
